import { MissionConfigurationDetailType } from '../api/api.g';
import type { MissionPromotionDisplayDto } from '../api/api.g';

export interface MissionReviewSummary {
  subtitle?: string;
  logoUrl?: string;
  salaryAmount?: number;
  salaryPoints?: number;
  pointsOnly?: boolean;
  promotionDisplay?: MissionPromotionDisplayDto;
}

export interface ScenarioNotice {
  isActive?: boolean;
  expiresAtUtc?: Date | string;
  refreshAfterSeconds?: number;
}

export const scenarioReviewRemaining = (deadline: number, now: number) => Math.max(0, Math.ceil((deadline - now) / 1000));

export const scenarioReviewChanged = (previous?: ScenarioNotice, current?: ScenarioNotice) => !!current?.isActive &&
  (!previous?.isActive || String(previous.expiresAtUtc) !== String(current.expiresAtUtc));

export const missionReviewContent = (missionName: string, details?: readonly { type?: number; text?: string }[], notice?: ScenarioNotice,
  summary?: MissionReviewSummary) => ({
  missionName,
  summary,
  scenario: details?.find(item => item.type === MissionConfigurationDetailType.Scenario)?.text ?? '',
  instructions: details?.filter(item => item.type !== MissionConfigurationDetailType.Scenario).map(item => item.text ?? '').join('\n\n') ?? '',
  notice,
});
